import React, { ReactNode } from 'react';
import PWAProvider from './pwa-provider';
import PWAInstallBanner from './install-banner';
import PWAUpdateNotification from './update-notification';

interface PWAWrapperProps {
  children: ReactNode;
  showInstallBanner?: boolean;
  showUpdateNotification?: boolean;
  installBannerVariant?: 'banner' | 'modal' | 'toast';
  updateNotificationVariant?: 'banner' | 'toast';
}

export const PWAWrapper: React.FC<PWAWrapperProps> = ({
  children,
  showInstallBanner = false, // Disabled - moved to Settings page
  showUpdateNotification = true, // 'New version available' nudge (registerType: 'prompt')
  installBannerVariant = 'banner',
  updateNotificationVariant = 'banner',
}) => {
  return (
    <PWAProvider>
      {children}

      {/* PWA install/update UI moved to Settings page */}
      {showInstallBanner && (
        <PWAInstallBanner
          variant={installBannerVariant}
          autoShow={true}
          onInstall={() => {
            console.log('[PWA] App installed successfully');
          }}
          onDismiss={() => {
            console.log('[PWA] Install banner dismissed');
          }}
        />
      )}

      {showUpdateNotification && (
        <PWAUpdateNotification
          variant={updateNotificationVariant}
          autoShow={true}
          onUpdate={() => {
            console.log('[PWA] App updated successfully');
          }}
          onDismiss={() => {
            console.log('[PWA] Update notification dismissed');
          }}
        />
      )}
    </PWAProvider>
  );
};

export default PWAWrapper;
